<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow" [ngClass]="{
						'text-danger': item.is_enabled === 0,
						'text-warning': item.is_enabled === 1 && item.is_onboarded === 0 }">

					<td [hidden]="!fieldsToShow.includes('is_enabled')" class="cp-icon-cell">
						<span class="cp-hidden-content">{{ item.is_enabled }}</span>
						<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success" placement="end"
							ngbTooltip="Enabled - login permitted"></fa-icon>
						<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger" placement="end"
							ngbTooltip="Disabled - login not permitted"></fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__onboard_status')" class="cp-icon-cell">
						<span class="cp-hidden-content">{{ item.is_onboarded }}</span>
						<fa-icon *ngIf="item.is_onboarded === 0" [icon]="['fas', 'exclamation-triangle']" size="sm" placement="end"
							class="text-danger" [ngbTooltip]="item['__onboard_status']">
						</fa-icon>
						<fa-icon *ngIf="item.is_onboarded === 1" [icon]="['fas', 'check']" size="sm" placement="end" class="text-success"
							[ngbTooltip]="item['__onboard_status']">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('name')" class="cp-chopped-col-long">
						<a [routerLink]="['/' + ac.urls.users, item.id]" [ngbTooltip]="item.name">{{ item.name }}</a>
						<!-- - {{ changeNameToLastFirst(item.name) }} -->
					</td>
					<td [hidden]="!fieldsToShow.includes('org_name')" class="cp-chopped-col-long">
						<span [ngbTooltip]="item.org_name">
							{{ item.org_name && item.org_name !== '' ? item.org_name : '-' }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('email')" class="cp-chopped-col-long">
						<span [ngbTooltip]="item.email">
							{{ item.email }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('role')" class="cp-icon-cell">
						<fa-icon [icon]="ac.userRoleIcons[item.role]" size="sm" [ngbTooltip]="ac.userRoleLabels[item.role]"></fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__notifications')" class="cp-icon-cell">
						<fa-icon *ngIf="item.notifications == null" [icon]="['fas', 'exclamation-triangle']" size="sm" placement="start"
							class="text-danger" [ngbTooltip]="item['__notifications'] ? item['__notifications'] : ''">
						</fa-icon>
						<fa-icon *ngIf="item.notifications != null" [icon]="['fas', 'check']" size="sm" placement="start"
							class="text-success" [ngbTooltip]="item['__notifications'] ? item['__notifications'] : ''">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__num_packages')" class="text-center">{{ item['__num_packages'] }}</td>
					<td [hidden]="!fieldsToShow.includes('__num_keys')" class="text-center">{{ item['__num_keys'] }}</td>
					<td [hidden]="!fieldsToShow.includes('__num_groups')" class="text-center">{{ item['__num_groups'] }}</td>

					<td [hidden]="!fieldsToShow.includes('added_on')" class="text-center text-nowrap">
						<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
							{{ item.added_on | timeback }}
						</div>
					</td>
					<td [hidden]="!fieldsToShow.includes('last_login')" class="text-center text-nowrap">
						<div *ngIf="item.last_login" [ngbTooltip]="item.last_login | date: ac.shortPageDateTimeFmt">
							{{ item.last_login | timeback }}
						</div>
					</td>
					<td [hidden]="!fieldsToShow.includes('__flag')" class="p-0 text-center">
						<img *ngIf="item['__flag']" [src]="item['__flag']" class="cp-list-flag" [ngbTooltip]="item.last_login_location"
							loading="lazy" />
					</td>
					<td [hidden]="!fieldsToShow.includes('last_download')" class="text-center text-nowrap">
						<div *ngIf="item.last_download" [ngbTooltip]="item.last_download | date: ac.shortPageDateTimeFmt">
							{{ item.last_download | timeback }}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>